import type { Notification } from "../utils/types"

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    notifications: [] as Notification[]
  }),
  getters: {
    allNotifications(): Notification[] {
      return this.notifications
    }
  },
  actions: {
    addNotification(notification: Notification) {
      this.notifications.push(notification)
    },

    removeNotification(id: string) {
      this.notifications = this.notifications.filter((n) => n.id !== id)
    }
  }
})
